/**
 * Instant Cart Page Redirect
 * This file is loaded WITHOUT defer to execute immediately in <head>
 * Redirects /cart page before content renders
 *
 * Safety: Only runs on exact /cart path, doesn't affect:
 * - Cart drawer functionality on other pages
 * - Cart API endpoints
 * - Cart-related sections
 */

(function() {
  'use strict';

  // Only redirect if we're on the exact /cart page
  // This won't affect /cart.js, /cart/add, or other cart endpoints
  if (window.location.pathname === '/cart' || window.location.pathname === '/cart/') {
    // Set flag for cart drawer to open after redirect
    try {
      sessionStorage.setItem('nms-open-cart-drawer', 'true');
    } catch (e) {
      // Silently fail if sessionStorage is not available (privacy mode)
      console.warn('Could not set cart drawer flag:', e);
    }

    // Redirect to homepage (replace avoids adding to browser history)
    window.location.replace('/');
  }
})();
